import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/columnItemList',
    name: 'columnItemList',
    component: () => import('@/views/ColumnItemList.vue')
  },
  {
    path: '/columnItemContent',
    name: 'columnItemContent',
    component: () => import('@/views/ColumnItemContent.vue')
  },
  {
    path: '/perQuery',
    name: 'PerQuery',
    component: () => import('@/views/PerQuery.vue')
  },
  {
    path: '/perObject',
    name: 'PerObject',
    component: () => import('@/views/PerObject.vue')
  },
  {
    path: '/perStatement',
    name: 'PerStatement',
    component: () => import('@/views/PerStatement.vue')
  },
  {
    path: '/entQuery',
    name: 'EntQuery',
    component: () => import('@/views/EntQuery.vue')
  },
  {
    path: '/entObject',
    name: 'EntObject',
    component: () => import('@/views/EntObject.vue')
  },
  {
    path: '/entStatement',
    name: 'EntStatement',
    component: () => import('@/views/EntStatement.vue')
  },
  {
    path: '/internetBank',
    name: 'InternetBank',
    component: () => import('@/views/InternetBank.vue')
  },
  {
    path: '/navigate',
    name: 'Navigate',
    component: () => import('@/views/Navigate.vue')
  },
  {
    path: '/map',
    name: 'Map',
    component: () => import('@/views/Map.vue')
  },
  {
    path: '/counter',
    name: 'Counter',
    component: () => import('@/views/Counter.vue')
  },
  {
    path: '/docView',
    name: 'DocView',
    component: () => import('@/views/DocView.vue')
  },
  {
    path: '/questionAnswer',
    name: 'QuestionAnswer',
    component: () => import('../views/QuestionAnswer.vue')
  },
  {
    path: '/txMap',
    name: 'txMap',
    component: () => import('../views/TxMap.vue')
  }
]

const router = new VueRouter({
  mode: process.env.VUE_APP_TARGET_MODE,
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes: routes
})

export default router
